import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { languageReducer, toastReducer, customerStoriesReducer } from ".";

const reducers = combineReducers({
  language: languageReducer,
  toast: toastReducer,
  customer_stories: customerStoriesReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["language", "toast", "customer_stories"], //로컬 스토리지에 지속적으로 저장
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const homeStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: false,
});

export type HomeRootState = ReturnType<typeof homeStore.getState>;
export type HomeAppDispatch = typeof homeStore.dispatch;

export const useHomeAppDispatch = () => useDispatch<HomeAppDispatch>();
export const useHomeAppSelector: TypedUseSelectorHook<HomeRootState> = useSelector;
